import React from "react";
import Helmet from "react-helmet";

const Title = ({ children }) => {
  return (
    <Helmet>
      <title>{children || "Spectro"}</title>
    </Helmet>
  );
};

export default Title;
